import { usersClient } from './client';

// ── Photo upload (used by the maid application form) ────────────────────────

export async function getPhotoUploadUrl() {
  const res = await usersClient.get('/users/me/photo-upload-url');
  return res.data.data as { uploadUrl: string; s3Key: string };
}

/** Uploads a JPEG file directly to S3 via a pre-signed PUT URL. */
export async function uploadPhotoToS3(uploadUrl: string, file: File) {
  await fetch(uploadUrl, {
    method:  'PUT',
    headers: { 'Content-Type': 'image/jpeg' },
    body:    file,
  });
}

export async function getIdDocUploadUrl() {
  const res = await usersClient.get('/users/me/id-doc-upload-url');
  return res.data.data as { uploadUrl: string; s3Key: string };
}

/** Uploads an ID document directly to S3 via a pre-signed PUT URL. */
export async function uploadIdDocToS3(uploadUrl: string, file: File) {
  await fetch(uploadUrl, {
    method: 'PUT',
    body:   file,
  });
}
